// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7ce9c459] .el-tabs__content {\n  height: calc(100% - 37px);\n}\n[data-v-7ce9c459] .el-tabs__content .el-tab-pane {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
